import { useRef } from 'react';
import { useSearchField } from 'react-aria';
import { useSearchFieldState } from 'react-stately';

import { mergeRefs } from '../../lib/mergeRefs';
import { Glyph } from '../common/Glyph';

import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';
import styles from './CommandPaletteSearchField.module.css';

export function CommandPaletteSearchField(props) {
  const inputRef = useRef();
  const searchFieldState = useSearchFieldState(props);
  const searchField = useSearchField(props, searchFieldState, inputRef);

  return (
    <div className={styles.root} style={props.style}>
      {props.label && <label {...searchField.labelProps}>{props.label}</label>}

      <input
        {...searchField.inputProps}
        ref={mergeRefs([inputRef, props.ref])}
        className={styles.input}
      />

      <div className={styles.iconWrapper}>
        <span className={styles.magnifierIconWrapper}>
          <Glyph
            className={styles.magnifierIcon}
            source={glyph.core.magnifyingglass}
            color={theme.icon.color_body_light}
            size={theme.icon.size_default}
          />
        </span>
      </div>

      {props.children}
    </div>
  );
}
